import { Box, IconButton } from '@mui/material'
import { EthAccountButton } from '@xylabs/sdk-react'
import { useContext } from 'react'
import { MdRefresh } from 'react-icons/md'

import { EntityContext } from '../../../../Contexts'

const LargeUp: React.FC = () => {
  const entity = useContext(EntityContext)

  if (entity) {
    const address = entity.address

    const onRefresh = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      event.stopPropagation()
    }

    return (
      <Box display="flex" flexGrow={1} justifyContent="space-between" padding={0.5}>
        <Box display="flex" flexGrow={1} justifyContent="flex-start">
          <Box display="flex">
            <EthAccountButton variant="outlined" address={address} full iconSize={16} />
          </Box>
        </Box>
        <Box alignItems="center" display="flex" flexGrow={1} justifyContent="flex-end">
          <IconButton onClick={onRefresh}>
            <MdRefresh />
          </IconButton>
        </Box>
      </Box>
    )
  }
  return null
}

export default LargeUp
